/* eslint-disable */
import styled from 'styled-components'
import { OUTLINE_COLOR, FONT_BASE_COLOR } from '@CSSVars/colors'

import { BREAK_POINT_MD } from '@CSSVars/variables'



export const _Container = styled.div`
  height: inherit;
  overflow: hidden;
  .embla {
    max-width: 48rem;
    margin: auto;
    --slide-height: 19rem;
    --slide-spacing: 1rem;
    --slide-size: 100%;

    --theme-color: ${FONT_BASE_COLOR};
  }
  .embla__viewport {
    overflow: hidden;
  }
  .embla__container {
    backface-visibility: hidden;
    display: flex;
    touch-action: pan-y pinch-zoom;
    margin-left: calc(var(--slide-spacing) * -1);

  }
  .embla__slide {
    flex: 0 0 var(--slide-size);
    min-width: 0;
    padding-left: var(--slide-spacing);
  }
  .embla__slide__number {
    box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
    border-radius: 1.8rem;
    font-size: 4rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--slide-height);
  }
  .embla__controls {
    display: grid;
    grid-template-columns: auto 1fr;
    justify-content: space-between;
    gap: 1.2rem;
    margin-top: 1.8rem;
  }
  .embla__buttons {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.6rem;
    align-items: center;
  }
  .embla__button {
    -webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);
    -webkit-appearance: none;
    appearance: none;
    background-color: transparent;
    touch-action: manipulation;
    display: inline-flex;
    text-decoration: none;
    cursor: pointer;
    margin: 0;
    z-index: 1;
    color: var(--text-body);
    display: flex;
    align-items: center;
    justify-content: center;

    width: 27px;
    height: 27px;
    border-radius: 50%;
    background-color: white;
    border: 1px solid ${OUTLINE_COLOR};
    padding: 5px;
    box-sizing: border-box;

    position: absolute;
    top: 50%;
    transform: translateY(-50%);

  }

  .embla__button--next {
    right: 10px;

    svg {
      transform: scale(-1);
    }
  }

  .embla__button--prev {
    left: 10px;
  }

  .embla__button:disabled {
    color: var(--detail-high-contrast);
    opacity: .3;
  }
  .embla__button__svg {
    width: 100%;
    height: 100%;
    fill: var(--theme-color);
  }
  .embla__dots {
    width: 50px;
    position: absolute;
    bottom: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;

  }

  .embla__dot__container {
    display: flex;
  }

  .embla__dots__viewport {
    overflow: hidden;
  }

  .embla__dot {
    content: '';
    margin: 0 2px;

    background-color: white;
    touch-action: manipulation;
    display: inline-flex;
    text-decoration: none;
    cursor: pointer;
/*    border: 1px solid var(--theme-color);*/
    padding: 0;
    width: 6px;
    height: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    opacity: .7;
    transform: scale(.7);
  }
  .embla__dot:after {
    content: '';
    width: 6px;
  }


  .embla__dot--selected-second-near {
    opacity: .7;
    transform: scale(.85);
  }

  .embla__dot--selected-near {
    opacity: .7;
    transform: scale(.95);
  }

  .embla__dot--selected {
    opacity: 1;
    transform: scale(1);
  }
`

export const _PrevFade = styled.div`
  content: "";
  width: 120px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(90deg, #FFF 4.28%, rgba(255, 255, 255, 0.00) 95.71%);
  z-index: 1;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`

export const _NextFade = styled.div`
  content: "";
  width: 120px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(270deg, #FFF 4.28%, rgba(255, 255, 255, 0.00) 95.71%);

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`
